import { SpinLoading as AntdMobileSpinLoading } from "antd-mobile";
import { BaseLoadingProps } from "./Loading.types";
import "./Loading.scss";

// App loading SVG spinner (same as in index.html)
const AppSpinner = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="46"
    height="47"
    viewBox="0 0 46 47"
    fill="none"
    className="loading__app-spinner"
  >
    <path
      d="M27.7066 0.765805C28.2303 0.850745 28.6947 1.14034 28.9967 1.57655C29.2988 2.01242 29.4137 2.55918 29.3172 3.09089C29.2207 3.6226 28.9209 4.09408 28.4849 4.39596C28.0488 4.69817 27.5122 4.80603 26.9921 4.70147C25.3888 4.37637 23.7414 4.24698 22.0991 4.3194C17.8362 4.49731 13.6318 6.08542 10.2776 8.81825C1.68365 15.42 0.101076 29.387 7.35775 37.9211C14.1743 46.7812 28.5728 48.4003 37.3634 40.9174C40.937 38.0332 43.5641 33.961 44.7116 29.4578C45.1579 27.724 45.3924 25.9316 45.4066 24.1331C45.4591 25.9308 45.2914 27.7389 44.9061 29.5041C43.9184 34.0867 41.4051 38.3527 37.8269 41.4667C29.0729 49.5339 13.6917 48.6306 5.82922 39.2109C-2.46425 30.2004 -1.52431 14.3878 8.16146 6.31046C11.9229 3.00239 16.8026 0.925786 21.8551 0.527242C23.8019 0.368423 25.7713 0.448194 27.7066 0.765805Z"
      fill="url(#paint0_linear_loading)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_loading"
        x1="26"
        y1="0.999999"
        x2="48"
        y2="44"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAF24" />
        <stop offset="0.429833" stopColor="#1673FF" />
        <stop offset="0.777375" stopColor="#1673FF" />
        <stop offset="1" stopColor="#BD16FF" />
      </linearGradient>
    </defs>
  </svg>
);

export const Loading: React.FC<BaseLoadingProps> = ({
  children,
  spinning = true,
  tip,
  variant = "primary",
  size = "md",
  color = "default",
  className = "",
  testId,
  ...props
}) => {
  const loadingClass = [
    "loading",
    `loading--${variant}`,
    `loading--${size}`,
    spinning && "loading--spinning",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  // Use app spinner for 'app' variant
  const useAppSpinner = variant === "app";

  if (children) {
    return (
      <div className={loadingClass} data-testid={testId}>
        {spinning && (
          <div className="loading__overlay">
            {useAppSpinner ? (
              <AppSpinner />
            ) : (
              <AntdMobileSpinLoading
                className="loading__spinner"
                color={color}
                {...props}
              />
            )}
            {tip && <div className="loading__tip">{tip}</div>}
          </div>
        )}
        {children}
      </div>
    );
  }

  return (
    <div className={loadingClass} data-testid={testId}>
      {useAppSpinner ? (
        <AppSpinner />
      ) : (
        <AntdMobileSpinLoading
          className="loading__spinner"
          color={color}
          {...props}
        />
      )}
      {tip && <div className="loading__tip">{tip}</div>}
    </div>
  );
};

export default Loading;
